import React from 'react';
import { Input, Form, Label, FormGroup } from 'reactstrap';
// import { auth } from '../../firebase';
import { auth } from '../../Api'
import * as authRedux from "../../redux/auth/action";
import { emailProblem, passwordProblem } from '../../utils/signin';
import { setAdminToken, takeLoginNotice, setCompanySuspended, clearCompanySuspended, setTermsRequired, TERMS_PAGE } from '../../utils/session';
import { formatServerMessage } from '../../utils/serverErrors';
import { rememberAccount } from '../../utils/accountType';
import SiteLayout from '../../components/site/SiteLayout';
import { SIGNUP_PATH, signupOpen } from '../../components/site/siteLinks';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

// The sign-in page (/authentication/login2), in the Mobiliis design inside the main website's header and footer
// (components/site/). "New to Mobiliis? Start a free trial" only while sign-up is open (signup/info).

class Login2 extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			email: '',
			password: '',
			error: null,
			showAlert: false,
			// The email address is not confirmed yet: the alert offers "Send the email again"
			unverified: false,
			resendBusy: false,
			resendMessage: null,
			// signup/info: whether sign-up is open (the header's and this page's "Start a free trial")
			signupInfo: null,
		};
		this.toggle = this.toggle.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onInputChange = this.onInputChange.bind(this);
		this.doLogin = this.doLogin.bind(this);
		this.doLoginServer = this.doLoginServer.bind(this);
		this.showErrors = this.showErrors.bind(this);
	}
	componentDidMount() {
		// e.g. "Your session has expired. Please log in again." set by Api/BaseApi.js
		const notice = takeLoginNotice();
		if (notice) {
			this.setState({ showAlert: true, alertMessage: notice });
		}
		auth.getSignupInfo()
			.then((res) => {
				if (!this.unmounted && res && res.data && res.data.code == 200) {
					this.setState({ signupInfo: res.data });
				}
			})
			.catch(() => {});
	}
	componentWillUnmount() {
		this.unmounted = true;
	}
	toggle() {
		this.setState({
			showAlert: !this.state.showAlert,
			unverified: false,
			resendMessage: null
		});
	}
	// "Send the email again" (laravel AuthController@resend): with the email and password just typed
	resendEmail() {
		const { email, password } = this.state;
		this.setState({ resendBusy: true, resendMessage: null });
		auth.resendConfirmationEmail({ email, password })
			.then((res) => {
				this.setState({ resendBusy: false, resendMessage: formatServerMessage(res.data.message, 'The email could not be sent. Please try again.') });
			})
			.catch(() => this.setState({ resendBusy: false, resendMessage: 'Could not reach the server. Please try again.' }));
	}
	// Only that the email looks like an address and the password is not empty (utils/signin.js); the server decides the
	// rest. They used to be the old template's checks (validators.js), which refused a "+" in an email and any symbol or
	// space in a password, so people who had signed up with one could not sign in.
	onInputChange(event) {
		this.setState({
			[event.target.name]: event.target.value,
			[event.target.name + 'Touched']: true
		});
	}
	validForm() {
		return emailProblem(this.state.email) === null && passwordProblem(this.state.password) === null;
	}
	// The field's problem once something has been typed in it
	showErrors(fieldName) {
		if (!this.state[fieldName + 'Touched']) {
			return '';
		}
		const problem = fieldName === 'email' ? emailProblem(this.state.email) : passwordProblem(this.state.password);
		return problem ? <div className="error mb-2"><span className="error">{problem}</span></div> : '';
	}
	doLoginServer(event) {
		const { email, password } = this.state;
		let req = {}
		req.email = email
		req.password = password
		// req.is_customer = true
		auth.signin(req)
			.then((res) => {
				this.setState(() => ({
					email: email,
					password: password,
				}));
				if (res.data.code == 200) {
					localStorage.setItem('access_token', res.data.data.token);
					// Sent as "Authorization: Bearer" on admin calls (see Api/BaseApi.js). Never log it.
					setAdminToken(res.data.admin_token);
					localStorage.setItem('mo_user', JSON.stringify(res.data.data));
					this.props.saveToken({ token: res.data.data.token })
					localStorage.setItem('admin_level', res.data.data.level)
					localStorage.setItem('admin_id', res.data.data.id)
					localStorage.removeItem('mainadmin_id')
					localStorage.removeItem('main_mo_user')
					localStorage.removeItem('main_admin_level')

					// A suspended company's own admin is signed in but kept on the Account page's Billing tab
					// (see layouts/layout-components/suspension/suspension-banner.js)
					if (res.data.suspended === true && res.data.data.level == "c") {
						setCompanySuspended(res.data.suspended_message);
					} else {
						clearCompanySuspended();
					}
					// A company admin whose company has not accepted the current Terms and Conditions: that page first
					const mustAcceptTerms = res.data.terms_required === true && res.data.data.level == "c";
					setTermsRequired(mustAcceptTerms);

					// Company or Private account (utils/accountType.js); the super admin and resellers choose a company later
					rememberAccount(res.data.data.level === "c" ? res.data.data : res.data.data.level === "d" ? res.data.data.company : null);
					if (res.data.data.level == "c") {
						localStorage.setItem("companyId", res.data.data.id)
						console.log("res.data.data.name:", res.data.data.name)
						localStorage.setItem('companyName', res.data.data.name)
						localStorage.setItem('companyInfo', JSON.stringify(res.data.data))
						this.props.history.push(mustAcceptTerms ? TERMS_PAGE : res.data.suspended === true ? "/account?tab=billing" : "/company-dashboard");
					} else if (res.data.data.level === "d" && res.data.data.company) {
						// A district manager works in their company's pages as its admin does (the server gives the
						// company's name, country and time zone only)
						localStorage.setItem("companyId", res.data.data.company_id)
						localStorage.setItem('companyName', res.data.data.company.name)
						localStorage.setItem('companyInfo', JSON.stringify(res.data.data.company))
						this.props.history.push("/company-dashboard");
					} else {
						this.props.history.push("/");
					}
				}
				if (res.data.code == 401) {
					this.setState({
						showAlert: true,
						alertMessage: res.data.message.error,
						unverified: res.data.unverified === true,
						resendMessage: null
					})
				}
			})
			.catch(error => {
				alert(error)
			});
	}
	doLogin(event) {
		const {
			email,
			password
		} = this.state;
		auth.doSignInWithEmailAndPassword(email, password)
			.then(() => {
				this.setState(() => ({
					email: email,
					password: password,
				}));
				this.props.history.push("/");
			})
			.catch(error => {
				alert('Invalid login id or password.');
			});
		event.preventDefault();
	}
	handleClick() {
		var elem = document.getElementById('loginform');
		elem.style.transition = "all 2s ease-in-out";
		elem.style.display = "none";
		document.getElementById('recoverform').style.display = "block";
	}
	render() {
		const { signupInfo, showAlert, alertMessage, unverified, resendBusy, resendMessage } = this.state;
		return (
			<SiteLayout page="login" signupInfo={signupInfo}>
				<div className="mob-narrow">
					<h1 className="mob-title">Log in</h1>
					<p className="mob-lede">Sign in to the Mobiliis admin website.</p>
					<Form className="mob-card" noValidate onSubmit={(event) => {
						event.preventDefault();
						if (this.validForm()) {
							this.doLoginServer(event);
						}
					}}>
						{/* The reply's message (wrong password, email not confirmed, session expired); with "Send the email
						    again" for an email address not confirmed yet */}
						{showAlert && (
							<div className={'mob-message ' + (unverified ? 'mob-message-info' : 'mob-message-error')} role="alert">
								<div>{alertMessage}</div>
								{unverified && (
									<div className="mt-2">
										<button type="button" className="mob-btn mob-btn-secondary" disabled={resendBusy} onClick={() => this.resendEmail()}>
											{resendBusy ? 'Sending...' : 'Send the email again'}
										</button>
										{resendMessage && <p className="mt-2 mb-0">{resendMessage}</p>}
									</div>
								)}
								<div className="mt-2">
									<button type="button" className="mob-link-button" onClick={this.toggle}>Close</button>
								</div>
							</div>
						)}
						<FormGroup>
							<Label for="email">Email</Label>
							<Input type="email" id="email" name="email" value={this.state.email} onChange={this.onInputChange} placeholder="Email"
								autoComplete="username" />
							{this.showErrors('email')}
						</FormGroup>
						<FormGroup>
							<Label for="password">Password</Label>
							<Input type="password" id="password" name="password" value={this.state.password} onChange={this.onInputChange}
								placeholder="Password" autoComplete="current-password" />
							{this.showErrors('password')}
						</FormGroup>
						<button type="submit" className="mob-btn mob-btn-primary mob-btn-block mt-3" disabled={!this.validForm()}>Log In</button>
						<p className="text-center mt-3 mb-0">
							<a href="/authentication/forgot-password">Forgot password?</a>
						</p>
						{signupOpen(signupInfo) && (
							<p className="text-center mt-2 mb-0">New to Mobiliis? <a href={SIGNUP_PATH}>Start a free trial</a></p>
						)}
					</Form>
				</div>
			</SiteLayout>
		);
	}
}

const mapStateToProps = ({ auth }) => {
	return {
		isAuthenticated: auth.isAuthenticated
	}
}

const mapDispatchToProps = (dispatch) => ({

	// setLoading: (val) => dispatch(setting.setLoading(val)),
	emailConfirmAction: (state) => dispatch(authRedux.emailConfirmAction(state)),
	// signin: (data) => api.signin(data),
	saveToken: (token) => dispatch(authRedux.saveToken(token)),
	getMeSuccess: (token) => dispatch(authRedux.getMeSuccess(token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login2));
